module.exports = __webpack_public_path__ + "img/nation.da48ecaa.png";